import {
  Component,
  ContentChild,
  HostBinding,
  Input,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';
import { toBoolean } from '../util/convert';

@Component({
  selector     : 'nz-card',
  encapsulation: ViewEncapsulation.None,
  template     : `
    <div class="ant-card-head" *ngIf="title">
      <h3 class="ant-card-head-title">
        <ng-template
          [ngTemplateOutlet]="title">
        </ng-template>
      </h3>
    </div>
    <div class="ant-card-extra" *ngIf="extra">
      <ng-template
        [ngTemplateOutlet]="extra">
      </ng-template>
    </div>
    <div class="ant-card-body">
      <ng-template
        *ngIf="!nzLoading"
        [ngTemplateOutlet]="body">
      </ng-template>
      <div *ngIf="nzLoading">
        <p class="ant-card-loading-block" style="width: 94%;"></p>
        <p>
          <span class="ant-card-loading-block" style="width: 28%;"></span><span class="ant-card-loading-block" style="width: 62%;"></span>
        </p>
        <p>
          <span class="ant-card-loading-block" style="width: 22%;"></span><span class="ant-card-loading-block" style="width: 66%;"></span>
        </p>
        <p>
          <span class="ant-card-loading-block" style="width: 56%;"></span><span class="ant-card-loading-block" style="width: 39%;"></span>
        </p>
        <p>
          <span class="ant-card-loading-block" style="width: 21%;"></span><span class="ant-card-loading-block" style="width: 15%;"></span><span class="ant-card-loading-block" style="width: 40%;"></span>
        </p>
      </div>
    </div>
  `,
  styles: [
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-card {
  background: #fff;
  border-radius: 2px;
  font-size: 14px;
  position: relative;
  transition: all .3s;
}
.ant-card:not(.ant-card-no-hovering):hover {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  border-color: transparent;
}
.ant-card-bordered {
  border: 1px solid #e9e9e9;
}
.ant-card-head {
  height: 48px;
  line-height: 48px;
  background: #fff;
  border-bottom: 1px solid #e9e9e9;
  padding: 0 24px;
  border-radius: 2px 2px 0 0;
}
.ant-card-head-title {
  font-size: 16px;
  display: inline-block;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}
.ant-card-extra {
  position: absolute;
  right: 24px;
  top: 14px;
}
.ant-card-body {
  padding: 24px;
  zoom: 1;
}
.ant-card-body:before,
.ant-card-body:after {
  content: " ";
  display: table;
}
.ant-card-body:after {
  clear: both;
  visibility: hidden;
  font-size: 0;
  height: 0;
}
.ant-card-loading .ant-card-body {
  user-select: none;
  padding: 0;
}
.ant-card-loading-content {
  padding: 24px;
}
.ant-card-loading-block {
  display: inline-block;
  margin: 5px 1% 0;
  height: 14px;
  border-radius: 2px;
  background: linear-gradient(90deg, rgba(207, 216, 220, 0.2), rgba(207, 216, 220, 0.4), rgba(207, 216, 220, 0.2));
  animation: card-loading 1.4s ease infinite;
  background-size: 600% 600%;
}
.ant-card-contain-grid .ant-card-body {
  margin: -0.5px;
  padding: 0;
}
.ant-card-grid {
  border-radius: 0;
  border: 0;
  box-shadow: 0 0 0 0.5px #e9e9e9, 0 0 0 0.5px #e9e9e9 inset;
  width: 33.33%;
  float: left;
  padding: 24px;
  transition: all .3s;
}
.ant-card-grid:hover {
  position: relative;
  z-index: 1;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.ant-card-wider-padding .ant-card-head {
  padding: 0 32px;
}
.ant-card-wider-padding .ant-card-body {
  padding: 24px 32px;
}
.ant-card-wider-padding .ant-card-extra {
  right: 32px;
}
.ant-card-padding-transition .ant-card-head,
.ant-card-padding-transition .ant-card-body {
  transition: padding .3s;
}
.ant-card-padding-transition .ant-card-extra {
  transition: right .3s;
}
@keyframes card-loading {
  0%,
  100% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}
`,
    `nz-card {
  display: block;
  position: relative;
}
`
  ],
  host: {
    '[class.ant-card]': 'true'
  }
})
export class NzCardComponent {
  private _borderd = true;
  private _loading = false;
  private _noHovering = false;

  @Input()
  @HostBinding('class.ant-card-bordered')
  set nzBordered(value: boolean) {
    this._borderd = toBoolean(value);
  }

  get nzBordered(): boolean {
    return this._borderd;
  }

  @ContentChild('title') title: TemplateRef<void>;
  @ContentChild('extra') extra: TemplateRef<void>;
  @ContentChild('body') body: TemplateRef<void>;

  @Input()
  set nzLoading(value: boolean) {
    this._loading = toBoolean(value);
  }

  get nzLoading(): boolean {
    return this._loading;
  }

  @Input()
  @HostBinding('class.ant-card-no-hovering')
  set nzNoHovering(value: boolean) {
    this._noHovering = toBoolean(value);
  }

  get nzNoHovering(): boolean {
    return this._noHovering;
  }
}
